/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import HomePageLayout from '../components/Layouts/HomePageLayout';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
const Homepage = () => {
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.HOME
    });
  }, []);
  return /*#__PURE__*/_jsx(HomePageLayout, {});
};
export default Homepage;